import axios from 'axios';
import {message} from "ant-design-vue";
import {AccessToken, CheckedCompanyAppId} from "./constant";
import {getSign} from "@/utils/common";
import {nanoid} from "nanoid";
import {useRouter} from "vue-router";
const router = useRouter()
// let baseURL = 'http://127.0.0.1:8788'
let baseURL = 'https://api.torchpix.com'
// const baseURL = process.env.VUE_APP_BASE_URL;
console.log(baseURL);
//创建axios实例
const axiosInstance = axios.create({
    baseURL: baseURL,
    timeout: 300000, //请求超时时间
    withCredentials: true, //允许携带cookie
});
//请求拦截
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem(AccessToken)
    if(token){
        config.headers['Authorization'] = token
    }
    const companyAppId = localStorage.getItem(CheckedCompanyAppId)
    if(companyAppId){
        config.headers['CompanyAppId'] = companyAppId
    }
    let timeString = new Date().getTime()
    let nanoidstring = nanoid()
    config.headers['request-time'] = timeString
    config.headers['request-nanoid'] = nanoidstring
    let string2 = timeString.toString()+nanoidstring
    config.headers['sign'] = getSign(string2)
    // Object.assign(config['headers'], {Authorization: `Bearer xxxxxx`});
    // config['withCredentials'] = true;
    return config;
});
//响应拦截
// 到期后需要换取 token
axiosInstance.interceptors.response.use(
    response => {
        if(response.headers['content-type'] && response.headers['content-type'].indexOf('application/octet-stream') > -1){
            return response
        }
        if (response.request.responseType === 'arraybuffer'){
            return response
        }
        //到期后自动更换token
        if(!!response.headers['refresh-token']){
            localStorage.setItem(AccessToken, response.headers['refresh-token']);
        }
        return response.data;
    },
    error => {
        if (error.response.status === 404) {
            message.error("接口请求错误，请求地址404", 2)
        }else if (error.response.status === 400) {
            message.error(error.response.data.message, 2)
        }else if (error.response.status === 405) {
            message.error(error.response.data.message, 2)
        }else if (error.response.status === 401) {


            //删除无效token跳转登录页面
            window.localStorage.removeItem('Authorization');
            if (window.location.pathname.indexOf('auth') < 0) {
                message.error("登录超时, 请重新登录", () => {
                    setTimeout(() => {
                        // window.location.href = '/login/index';
                        router.push({name:'login'})
                    }, 1000);
                });
            }

        }
        return Promise.reject(error);
    },
);

export default axiosInstance;
